import type { Guide, GuideRecordHint } from '../types';

/** S-20.10-01 — odpięcie auta przez planistę do wyjazdu na załadunek (scenariusz e2e 1, ścieżka FTL-01). */
const ASSIGNED: GuideRecordHint = {
  description: 'zlecenie obsadzone Twoim pojazdem',
  listPath: '/user-offers',
  listFilter: { forklift: 'hide', dzial: 'FTL' },
};

export const guide: Guide = {
  flagKey: 'unassignBeforeDeparture',
  title: 'Odpięcie auta przez planistę do wyjazdu na załadunek',
  whatItDoes:
    'Dopóki pojazd nie wyruszył na załadunek, planista FTL odpina go od zlecenia sam, z powodem (co najmniej 10 znaków). Wyjazd szacujemy: początek okna załadunku minus dolot z pozycji pojazdu. Po wyjeździe — jak dotąd — wniosek o odpięcie do przełożonego. Planista odpina tylko swoje pojazdy, a historia zmian zapisuje adnotację „przed wyjazdem na załadunek” z szacunkiem.',
  audience: ['planista FTL', 'Team Leader (planista główny)'],
  presentationItems: ['S-20.10-01'],
  steps: [
    {
      route: '/user-offers/:orderId/show',
      record: ASSIGNED,
      target: 'unassign-self',
      title: 'Przed wyjazdem — „Odepnij”',
      description:
        'Karta mówi, do kiedy (szacunkowo) odpinasz sam, bez wniosku, i skąd ten szacunek. Bez powodu przycisk jest nieaktywny.',
      action: 'Wpisz powód odpięcia i kliknij „Odepnij”.',
      recorder: { account: 'ftl', demo: { kind: 'order', number: 'DEMO/2026/10/U01' } },
    },
    {
      route: '/user-offers/:orderId/show',
      record: ASSIGNED,
      target: 'unassign-departed',
      title: 'Po wyjeździe — wniosek do przełożonego',
      description:
        'Gdy okno załadunku trwa albo TMS ma już status realizacji, karta mówi „Auto wyruszyło na załadunek — odpięcie zatwierdza przełożony”, a zamiast „Odepnij” jest wniosek o odpięcie z powodem.',
      action: 'Wpisz powód (co najmniej 10 znaków) i kliknij „Wnioskuj o odpięcie”.',
      recorder: { account: 'ftl', demo: { kind: 'order', number: 'DEMO/2026/10/005' } },
    },
  ],
};
